// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__ecfsh","upload":"Small_upload__3BJTW","imageWrap":"Small_imageWrap__3ejW6","removeBtn":"Small_removeBtn__VO9of"};